// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"58d3a727","637":"65934c0f","819":"596d2dbc"}[chunkId] + ".chunk.css";
};